export const NAVIGATION_GO_PANEL = '@navigation/go-panel';
export const NAVIGATION_SET_MODAL = '@navigation/set-modal';
export const NAVIGATION_SET_POPOUT = '@navigation/set-popout';
export const NAVIGATION_SET_PROGRESS_VALUE = '@navigation/set-progress-value';
export const NAVIGATION_HIDE = '@navigation/hide';
